module.exports = __webpack_public_path__ + "img/hk.e26b78e.svg";